import React from 'react';
import { safeHTML } from '../../../utils/safeHTML';

const NoteValue = React.forwardRef(function NoteValue({ noteValue }, ref) {
  return (
    <div className={'w-modal__note-value'}>
      <span className={'w-modal__note-value-text'}>{safeHTML(noteValue)}</span>
    </div>
  );
});
export default NoteValue;
NoteValue.propTypes = {};
